// extracted by mini-css-extract-plugin
export default {"footer__language-buttons__placeholder":"footer__language-buttons__placeholder_D8VFl_RM"};